import { defineComponent as r, createElementBlock as n, openBlock as s, createVNode as a, renderSlot as t, unref as l, mergeProps as c, withCtx as u } from "vue";
import { RevButtonBase as i } from "@ds/components/ButtonBase";
const m = { class: "rounded-sm relative size-64 border" }, _ = /* @__PURE__ */ r({
  name: "DocumentSmallBase",
  __name: "DocumentSmallBase",
  props: {
    buttonAttrs: {}
  },
  setup(o) {
    return (e, d) => (s(), n("article", m, [
      a(l(i), c(o.buttonAttrs, { class: "focus-visible-outline-default-hi inline-block overflow-hidden rounded-[calc(0.375rem-1px)]" }), {
        default: u(() => [
          t(e.$slots, "default")
        ]),
        _: 3
      }, 16),
      t(e.$slots, "avatar")
    ]));
  }
});
export {
  _ as default
};
